import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconMenuMoreVertical';
/** Renders an SVG icon. */
const SvgMenuMoreVertical = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M16 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      />
    </svg>
  );
};
SvgMenuMoreVertical.displayName = displayName;
export default SvgMenuMoreVertical;
